export default __webpack_public_path__ + "161445edec393590c1e6f6c56aa0343a.svg";